import FormNav from "./FormNav";
import React from "react";
import { Link } from "react-router-dom";
import { focusTitle } from "./aria";

const Content = ({
  appID,
  content,
  application,
  history,
  isApplicationOpen,
  link,
  logo,
  logout,
  match,
  schemas,
  slug,
  isSubmitted,
  user
}) => {
  return (
    <div className="row">
      <FormNav
        appID={appID}
        application={application}
        history={history}
        isApplicationOpen={isApplicationOpen}
        logout={logout}
        match={match}
        orientation="vertical"
        setDestination={destination => {
          focusTitle();
          return history.push(destination);
        }}
        isSubmitted={isSubmitted}
        user={user}
      />
      <div className="col col-md-8 col-lg-9 py-4" id="intro">
        <h2 id="form-title" style={{ display: "none" }}>
          Welcome
        </h2>
        <div dangerouslySetInnerHTML={{ __html: content }} />
        <button
                  type="submit"
                  className="btn btn-primary float-right nav-btn"
                  onClick={() => {
                    focusTitle();
                    history.push(link);
                  }}
                >
                  Next
        </button>
      </div>
    </div>
  );
};

export default Content;



// WEBPACK FOOTER //
// ./src/Content.js